export const SET_SWITCH_USER_EMAIL = 'mac/SET_SWITCH_USER_EMAIL';
export const RESTORE_USER_EMAIL = 'mac/RESTORE_USER_EMAIL';
